import { Component } from '@angular/core';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { CaseServiceCause } from '../../cases/_types/case-service-cause';
import { FilterFieldConfig } from 'src/app/core/filter-panel/filter-field.model';
import { CasesServicesCausesService } from '../../cases/_services/cases-services-causes.service';

@Component({
    selector: 'app-cases-services-causes-list',
    templateUrl: './cases-services-causes-list.component.html',
    styleUrls: ['./cases-services-causes-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class CasesServicesCausesListComponent {

  public casesServicesCauses: CaseServiceCause[] = [];
  public caseServiceCauseTypes: any[] = [];

  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
    caseServiceCauseType: new Filter(FilterOperation.equals, 'caseServiceCauseType')
  };

  public typeOptions: { label: string; value: any }[] = [];
  public fieldsConfig: FilterFieldConfig[] = [
    { filter: this.filters.caseServiceCauseType, type: 'select', label: 'Tipo', options: this.typeOptions, base: true },
    { filter: this.filters.name, type: 'text', label: 'Nombre', base: true }
  ];
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    public casesServicesCausesService: CasesServicesCausesService,
    private topbarService: TopbarService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {
    
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Motivos de cancelación y citas atrasadas");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({} as CaseServiceCause);
    });
    this.allowWrite = true;//this.loginService.hasPermission("PROVIDERS_WRITE")
    this.allowDelete = true;//this.loginService.hasPermission("PROVIDERS_DELETE")
    this.loadCaseServiceCauseTypes();
  }

  public async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows }
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.casesServicesCausesService.all(params));
    this.casesServicesCauses = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  loadCaseServiceCauseTypes() {
    this.caseServiceCauseTypes = this.casesServicesCausesService.caseServiceCauseTypes();
    this.typeOptions.length = 0;
    this.typeOptions.push(...this.caseServiceCauseTypes);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(caseServiceCause: CaseServiceCause) {
    this.router.navigate(['casesServicesCauses/' + (caseServiceCause && Object.keys(caseServiceCause).length > 0 ? caseServiceCause.id : 0)]);
  }

  delete(caseServiceCause: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar la causa y sus motivos relacionados?",
        header: "Eliminar causa",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.casesServicesCausesService.delete(caseServiceCause.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Causa eliminada correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }
  }

}
